import { isBrowser } from 'ws-scripts/modules/environment';

export const getEnv = () => {
	if (!isBrowser) {
		return 'localhost';
	}
	if (window.location.hostname.includes('web-prod')) {
		return 'prod';
	} else if (window.location.hostname.includes('web-np')) {
		return 'nonprod';
	} else {
		return 'localhost';
	}
};
